module.exports = __webpack_public_path__ + "static/media/brentcomber_logo.6e6045ee.svg";